import React, { useEffect, useRef } from 'react'
import ModeSearch from '../ModeSearch/ModeSearch' // 新しいコンポーネントのパスは適宜調整してください
import Switch2 from '../Switch/Switch'
import MenuIcon2 from '../MenuIcon/MenuIcon'
import ManagementModule from './ManagementScreen.module.scss'
import FolderIcon from '@mui/icons-material/Folder'
import Tooltip from '@mui/material/Tooltip'

const ManagementScreenList = ({
  filteredModes,
  folders,
  selectedFolder,
  onFolderChange,
  searchText,
  setSearchText,
  displayAddBody,
  switchBody,
  selectedItem,
  selectedItemClassName,
  schoolIdName,
  handleCopyModeLink,
  handleCopyModeShareLink,
  handleModeStart,
  updateActive,
  updateActiveForTeacher,
  isChildSchool,
  displayAddFolderScreen,
  isAdmin,
  handleFolderDeletion,
  handleFolderEdition,
  isAuthorizedToCreatePrompt
}) => {
  const listContainerRef = useRef(null)
  const splitBarRef = useRef(null)

  const adjustStretchHeight = () => {
    if (listContainerRef.current && splitBarRef.current) {
      // 毎回バーの高さを初期化
      splitBarRef.current.style.height = `${0}px`
      const parentHeight = listContainerRef.current.scrollHeight
      const parentShowingHeight = listContainerRef.current.clientHeight
      splitBarRef.current.style.height = `${parentShowingHeight <= parentHeight ? parentHeight : parentShowingHeight}px`
    }
  }

  useEffect(() => {
    adjustStretchHeight()
    window.addEventListener('resize', adjustStretchHeight)
    return () => window.removeEventListener('resize', adjustStretchHeight)
  }, [])

  useEffect(() => {
    adjustStretchHeight()
  }, [folders, filteredModes, selectedFolder])

  return (
    <div className={ManagementModule.sidebar}>
      <div className={ManagementModule['sidebarheader-container']}>
        <div className={ManagementModule.sidebarheader}>
          <button
            className={`${ManagementModule['new-button']} ${
              !isAuthorizedToCreatePrompt ? ManagementModule['new-button--disabled'] : ''
            }`}
            onClick={() => {
              if (!isAuthorizedToCreatePrompt) return
              displayAddBody()
            }}
          >
            <span className={ManagementModule['text-sm']}>モード作成</span>
          </button>
          <ModeSearch placeholderMessage="モードを検索..." searchText={searchText} setSearchText={setSearchText} />
        </div>
        {!isChildSchool && (
          <div>
            <p>
              ※モードのテンプレートは
              <a target="_blank" rel="noreferrer" href={'https://www.notion.so/100-ab8069bf3ab444918766b2d417860e01'}>
                こちら
              </a>
            </p>
            <p>
              ※公式ガイド（操作マニュアル）は
              <a
                target="_blank"
                rel="noreferrer"
                href={'https://plaid-scallop-d50.notion.site/AI-9aceac5e9c744b0c8dc07eeb13533f8f?pvs=4'}
              >
                こちら
              </a>
            </p>
          </div>
        )}
      </div>
      <div className={ManagementModule['list-container']} ref={listContainerRef}>
        <ul className={`${ManagementModule.list} ${ManagementModule['folder-list']}`}>
          {!isAdmin && (
            <div className={ManagementModule['add-folder-button-container']}>
              <button
                className={`${ManagementModule['new-button']} ${ManagementModule['add-folder-button']} ${
                  !isAuthorizedToCreatePrompt ? ManagementModule['new-button--disabled'] : ''
                }`}
                onClick={() => {
                  if (!isAuthorizedToCreatePrompt) return
                  displayAddFolderScreen()
                }}
              >
                フォルダ作成
              </button>
            </div>
          )}
          {!isAdmin && !folders.some((_) => _.type === 'self') && (
            <p className={ManagementModule['add-folder-message']}>フォルダを追加してください。</p>
          )}
          {folders.length > 0 ? (
            folders.map((folder, i) => {
              return (
                <div key={i} className={ManagementModule.list} onClick={() => onFolderChange(folder)}>
                  <li
                    className={`${ManagementModule.list} ${ManagementModule['folder-list']} ${
                      selectedFolder.uid === folder.uid && ManagementModule[selectedItemClassName]
                    }`}
                  >
                    <FolderIcon />
                    <span>{`${folder.name ?? ''}`}</span>
                  </li>
                  <MenuIcon2
                    folder={folder}
                    handleFolderDeletion={(folder) => handleFolderDeletion(folder)}
                    handleFolderEdition={(folder) => handleFolderEdition(folder)}
                  />
                </div>
              )
            })
          ) : (
            <p className={ManagementModule['no-folder-message']}>フォルダを作成してください。</p>
          )}
        </ul>
        <div className={`${ManagementModule['split-bar']}`} ref={splitBarRef}>
          <span></span>
        </div>
        <ul className={`${ManagementModule.list} ${ManagementModule['mode-list']}`}>
          {filteredModes.length > 0 ? (
            filteredModes.map((item, index) => {
              return (
                <div key={index} className={ManagementModule.list}>
                  <li
                    onClick={() => switchBody(item)}
                    key={index}
                    className={`${ManagementModule.list} ${ManagementModule['mode-list']} ${
                      selectedItem === item.id ? ManagementModule[selectedItemClassName] : ''
                    }`}
                  >
                    <p className={ManagementModule['list-title']}>{item.prompt_title}</p>
                    <p className={ManagementModule['list-title-sub']}>表示順：{item.prompt_order}</p>
                    {item.editable === false && (
                      <b className={ManagementModule['list-title-sub2']}>
                        ※ {item.parentSchoolId !== 'gpt-teacher' ? schoolIdName[item.parentSchoolId] : '管理人'}
                        が作成したモードです
                      </b>
                    )}
                  </li>
                  <div className={ManagementModule['list-button-wrapper']}>
                    <Tooltip
                      title={
                        item.enable
                          ? '「無効」にすると生徒画面でモードが表示されないようになります。'
                          : '「有効」にすると生徒画面でモードが表示されるようになります。'
                      }
                      componentsProps={{
                        tooltip: {
                          sx: { width: '120px' }
                        }
                      }}
                      slotProps={{
                        popper: {
                          modifiers: [
                            {
                              name: 'offset',
                              options: {
                                offset: [0, -10]
                              }
                            }
                          ]
                        }
                      }}
                    >
                      <div>
                        <Switch2
                          id="themeDeafault"
                          key={item.id}
                          value={item.id}
                          checked={item.editable ? item.enable : item.active}
                          onChange={
                            item.editable
                              ? (e) => {
                                  updateActive(e, e.target.value, item)
                                }
                              : (e) => {
                                  updateActiveForTeacher(e, item)
                                }
                          }
                        />
                      </div>
                    </Tooltip>
                    <MenuIcon2
                      item={item}
                      handleCopyModeLink={handleCopyModeLink}
                      handleCopyModeShareLink={handleCopyModeShareLink}
                      handleModeStart={handleModeStart}
                    />
                  </div>
                  <span
                    className={`${ManagementModule['color-icon']}  ${
                      !item.modeColor ? ManagementModule['color-icon--hidden'] : ''
                    }`}
                    style={{ backgroundColor: item.modeColor ?? '' }}
                  ></span>
                </div>
              )
            })
          ) : (
            <p className={ManagementModule['no-mode-message']}>モードがありません。</p>
          )}
        </ul>
      </div>
    </div>
  )
}

export default ManagementScreenList
